import qs from 'qs'

export const STRAPI_BASE_URL = process.env.REACT_APP_STRAPI_ENDPOINT || 'http://localhost:1337'

export async function getArchivoPatrimonial() {
  try {
    const query = qs.stringify({
      populate: {
        heroItem: {
          populate: ['imagen']
        }
      }
    }, {
      encodeValuesOnly: true,
    });

    const url = `${STRAPI_BASE_URL}/api/fg-archivo-patrimonials?${query}`;
    
    const res = await fetch(url);
    
    if (!res.ok) {
      const errorData = await res.json();
      console.error('Error detallado de Strapi:', errorData);
      throw new Error(`Error ${res.status}`);
    }
    
    const data = await res.json();

    if (Array.isArray(data?.data)) return data.data[0] || null;
    return data.data || null;
  } catch (err) {
    console.error('Error cargando Archivo Patrimonial:', err);
    return null;
  }
}